import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52de8a00&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de8a00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52de8a00')) {
      api.createRecord('52de8a00', component.options)
    } else {
      api.reload('52de8a00', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52de8a00&scoped=true&", function () {
      api.rerender('52de8a00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proSubManage/index.vue"
export default component.exports